import { onScopeDispose, toValue, type MaybeRefOrGetter } from "vue";

type SoundOptions = {
  soundEnabled?: MaybeRefOrGetter<boolean>;
  volume?: number;
};

export default function useSound(source: string, options: SoundOptions = {}) {
  let audio: HTMLAudioElement | undefined;

  function getAudio() {
    if (audio == null) {
      audio = new Audio(source);
      audio.preload = "auto";
      audio.volume = Math.min(1, Math.max(0, options.volume ?? 1));
    }
    return audio;
  }

  function play() {
    if (!toValue(options.soundEnabled ?? true)) {
      return;
    }

    const sound = getAudio();
    sound.currentTime = 0;
    void sound.play().catch(() => undefined);
  }

  onScopeDispose(() => {
    audio?.pause();
    audio = undefined;
  });

  return { play };
}
